/**
* 监控管理
*/
<template>
  <div class="background">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>监控管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-select
          size="small"
          v-model="storeId"
          placeholder="请选择订单类型"
          @change="changeCamera"
        >
          <el-option
            v-for="type in payway"
            :label="type.key"
            :value="type.value"
            :key="type.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-from-item>
        <el-date-picker
          v-model="single"
          type="date"
          placeholder="选择日期"
          @change="maskClick"
        >
        </el-date-picker>
      </el-from-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="clickRecord"
          >记录</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="BackZhiBo"
          >回到直播</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-row :gutter="20">
      <el-col :span="6" class="">
        <div style="" class="bigBox">
          <div
            class="el-col-Div"
            v-for="(item, index) in CameraDevice"
            :key="Number(item.id)"
          >
            <!--                    <div :id="'video-container' + Number(index+1)">-->
            <!--                    </div>-->
            <div :id="'video-container' + Number(item.id)"></div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="记录" :visible.sync="dialogVisible" width="50%">
      <el-table
        :data="CameraDeviceLogList"
        style="width: 100%; max-height: 500px"
      >
        <el-table-column prop="openTime" label="时间"> </el-table-column>
        <el-table-column prop="camerlog" label="动作"> </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="clickDetail(scope.row)"
              type="success"
              plain
              size="small"
              v-if="scope.row.operate == 8"
              >详情</el-button
            >
            <el-button
              type="primary"
              plain
              size="small"
              @click="seeHuiFan(scope.row)"
              >回放</el-button
            >
            <!-- <el-button
              type="danger"
              plain
              size="small"
              @click="clickTrace(scope.row)"
              v-if="scope.row.wxUserId != null"
              >跟踪</el-button
            > -->
            <el-popover
              placement="right"
              trigger="click"
              :title="phoneText"
              @hide="hideTrace"
            >
              <el-table :data="JinMneList" height="300">
                <!-- 显示序号 -->
                <!-- <el-table-column type="index" width="50" label="序号"></el-table-column> -->

                <el-table-column
                  width="200"
                  property="openTime"
                  label="时间"
                ></el-table-column>
                <el-table-column
                  width="200"
                  property="desctions"
                  label="描述"
                ></el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      plain
                      size="small"
                      @click="seeHuiFan1(scope.row)">回放
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                slot="reference"
                type="danger"
                plain
                size="small"
                @click="clickTrace(scope.row)"
                v-if="scope.row.wxUserId != null"
                >跟踪</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="dialogFormDetail" width="50%">
      <el-form :model="OrderDesc" label-width="120px">
        <el-form-item label="订单号">
          <el-input
            v-model="OrderDesc.orderNum"
            autocomplete="off"
            style="width: 30vw"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="订单状态" :label-width="formLabelWidth">
          <el-input
            v-model="OrderDesc.orderStatus"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="订单内容" :label-width="formLabelWidth">
          <el-input
            v-model="OrderDesc.content"
            autocomplete="off"
            type="textarea"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="订单金额" :label-width="formLabelWidth">
          <el-input
            v-model="OrderDesc.price"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间" :label-width="formLabelWidth">
          <el-input
            v-model="OrderDesc.createTime"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="更新时间" :label-width="formLabelWidth">
          <el-input
            v-model="OrderDesc.updateTime"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormDetail = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="" :visible.sync="dialogTableTrace">
      <div class="PopTitle">
        <div class="PopTitleText" v-if="userPhone != ''">
          尾号【{{ userPhone.substring(userPhone.length - 4) }}】的相关记录
        </div>
        <div class="PopTitleText" v-else>用户id【{{ userId }}】的相关记录</div>

        <div class="PopDel">
          <image
            src="/static/Del.svg"
            mode=""
            class="PopDelImg"
            @click="closePop1"
          ></image>
        </div>
      </div>
      <div class="PopUserPhone">用户手机号：{{ userPhone }}</div>
      <el-table :data="traceData">
        <el-table-column
          property="date"
          label="日期"
          width="150"
        ></el-table-column>
        <el-table-column
          property="name"
          label="姓名"
          width="200"
        ></el-table-column>
        <el-table-column property="address" label="地址"></el-table-column>
      </el-table>
    </el-dialog> -->

    <!-- 分页组件 -->
    <!-- <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination> -->
  </div>
</template>

<script>
// import { OrderList, OrderRefund, OrderDelete  } from "../../api/payMG";
import {
  CameraDevice,
  CameraDeviceListreq,
  CameraUserDevice,
  orderById,
  getStoreList, // 获取门店列表
} from "../../api/api";

import EZUIKit from "../../components/ezuikit-js/ezuikit-js/ezuikit.js";

export default {
  data() {
    return {
      items: [],
      formInline: "",
      LogTime: "",

      colors: ["#007aff", "#4cd964", "#dd524d"],
      current: 0,
      colorIndex: 0,
      activeColor: "#007aff",
      styleType: "button",
      strings: " ",
      ColorStatus: new Map(),
      OrderColor: "",
      orderStatus: new Map(),
      userPhone: "",
      formLabelWidth: "120px",
      // 门店列表
      payway: [
        // { key: '全部订单', value: 0 },
        // { key: '已完成订单', value: 1 },
        // { key: '已取消订单', value: 2 },
        // { key: '已退款订单', value: 3 },
      ],
      //记录弹窗数据
      LogTime: "",
      single: "",
      dialogVisible: false, //弹窗是否显示
      dialogFormDetail: false, //详情的弹窗
      dialogFormTrace: false, //跟踪弹窗
      OrderDesc: {}, //详情的数据
      traceData: {}, //相关记录
      CameraDeviceLogList: [],
      urldemo: "https://ht.wteam.club/api",
      storeId: Number(localStorage.getItem("storeId")),
      CameraDevice: [],
      accessToken: "",
      url: "",
      JinMneList: [],
      OrderDesc: {},
      userId: "",
      IsHuiFan: false,
      localPlaybackAddress: "", // 本地回放录像
      type: "ourDomain",
      player: [],
      JinMneList: [],
      phoneText: "",
    };
  },
  onLoad(e) {},

  created(e) {
    this.getStoreLists();
    console.log("==created===", e);
    // this.storeId = localStorage.getItem("storeId");
    this.initSingle();
    this.CameraDeviceReq();
  },

  mounted(e) {
    console.log("...mounted...", e);
    this.orderStatus.set("0", "生成中");
    this.orderStatus.set("1", "已完成");
    this.orderStatus.set("2", "已取消");
    this.orderStatus.set("3", "已退款");

    this.ColorStatus.set("0", "color:orange");
    this.ColorStatus.set("1", "color:#25A785");
    this.ColorStatus.set("2", "color:gray");
    this.ColorStatus.set("3", "color:red");
    this.OrderColor = this.ColorStatus.get("1");

    this.CameraDeviceList();
  },
  formatRule(val) {
    val = val.replace(/`/g, "--");
    val = val.replace(/\\n/g, "\n");
    return val;
  },
  methods: {
    //获取门店列表
    getStoreLists() {
      //把localStorage里面的门店列表字符串转化成数组
      this.payway = localStorage.getItem("storeLitst")
        ? JSON.parse(localStorage.getItem("storeLitst"))
        : [];
      //给payway添加value属性
      this.payway.forEach((item, index) => {
        item.value = item.id;
      });
    },
    //点击搜索按钮
    search() {
      // this.CameraDeviceReq();
    },
    //改变门店监控
    changeCamera() {
      this.CameraDeviceReq();
    },
    //点击记录按钮
    clickRecord() {
      this.CameraDeviceList();
      this.dialogVisible = true;
    },
    //点击详情按钮
    clickDetail(row) {
      this.queryorderById(row.adminId);
      this.dialogFormDetail = true;
    },
    //获取详情数据
    queryorderById(id) {
      let url = this.urldemo + this.$api.orderById + "/" + id;
      this.$request(url, null, "GET", false).then((res) => {
        if (res.code == "0") {
          this.OrderDesc = res.data;
          this.OrderDesc.OrderColor = this.ColorStatus.get(
            res.data.orderStatus.toString()
          );
          this.OrderDesc.orderStatus = this.orderStatus.get(
            res.data.orderStatus.toString()
          );
        } else {
          this.$message.error("错误!");
        }
      });
    },
    //点击跟踪
    clickTrace(item) {
      // this.dialogFormTrace = true;
      // console.log("item", item);
      this.phoneText = "[" + item.phone + "]的相关记录";
      this.getCameraUserDevice(item.wxUserId);
    },
    //隐藏跟踪弹窗
    hideTrace() {
      this.phoneText = "";
      this.JinMneList = [];
    },
    initSingle() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = String(now.getMonth() + 1).padStart(2, "0");
      const currentDate = String(now.getDate()).padStart(2, "0");
      this.single = currentYear + "-" + currentMonth + "-" + currentDate;
    },
    BackZhiBo() {
      this.IsHuiFan = false;
      this.CameraDevice.forEach((item, index) => {
        item.url = item.hdAddress;
        this.initPlayer(item);
      });
      this.initSingle();
      this.CameraDeviceList();
    },
    seeHuiFan(item) {
      this.dialogVisible = false;
      this.IsHuiFan = true;
      this.LogTime = item.openTime;
      this.BakcCamera(item);
    },
    seeHuiFan1(item) {
      // 跟踪用户进门记录
      console.log("item", item);
      this.IsHuiFan = true;
      this.LogTime = item.openTime;
      this.single = item.openTime.split(" ")[0];
      this.CameraDeviceList();
      this.BakcCamera();
      // this.$refs.popup1.close();
      this.$refs["popover"].doClose();
      this.$refs.dialogFormDetail.close();
    },
    //格式化时间
    timeToTimestamp(date) {
      // let timestamp = Date.parse(new Date(time).toString());
      // //timestamp = timestamp / 1000; //时间戳为13位需除1000，时间戳为13位的话不需除1000
      // console.log(time + "的时间戳为：" + timestamp);

      var y = date.getFullYear();
      var m = date.getMonth() + 1; //注意这个“+1”
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;

      return y + "" + m + "" + d + "" + h + "" + minute + "" + second;
    },
    BakcCamera() {
      const currentDate = new Date(this.LogTime);
      // 将日期加一天
      let begin = this.timeToTimestamp(currentDate);
      currentDate.setDate(currentDate.getDate() + 1);
      let end = this.timeToTimestamp(currentDate);
      console.log("@@@@", currentDate);
      this.CameraDevice.forEach((item, index) => {
        // if (index == this.current) {
        item.url = item.localPlaybackAddress;
        if (item.url.indexOf("begin") == -1) {
          item.url = item.url + "?begin=" + begin + "&end=" + end;
        } else {
          item.url = item.url.replace(
            /begin=\d+&end=\d+/,
            "begin=" + begin + "&end=" + end
          );
        }
        this.initPlayer(item);
        // }
      });
    },
    getQueryString(params) {
      var reg = new RegExp("(^|&)" + params + "=([^&]*)(&|$)", "i"); //解析url地址
      var r = window.location.search.substr(1).match(reg);
      console.log(params);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    //点击日期回放
    maskClick(e) {
      console.log("maskClick事件:", this.single);
      //以T分割字符串，取出日期
      // this.single = this.single.split("T")[0];
      // this.single = e;
      // 把single变成2022-01-03格式
      let selectTime = new Date(this.single);
      this.single =
        selectTime.getFullYear() +
        "-" +
        ("0" + (selectTime.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + selectTime.getDate()).slice(-2);
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = String(now.getMonth() + 1).padStart(2, "0");
      const currentDate = String(now.getDate()).padStart(2, "0");
      let nowDate = currentYear + "-" + currentMonth + "-" + currentDate;
      // 不是今天就是回放
      if (nowDate == e) {
        this.IsHuiFan = false;
      } else {
        this.IsHuiFan = true;
      }
      // 获取进门记录
      this.CameraDeviceList();
      // this.LogTime = this.single + " 00:00:00";
      this.LogTime = this.single;
      // 获取回放
      this.BakcCamera();
    },
    onClickItem(e) {
      console.log(e);
      if (this.current !== e.currentIndex) {
        this.current = e.currentIndex;

        // 修改监控url
        if (this.IsHuiFan) {
          // 回放
          this.BakcCamera();
        } else {
          // 直播
          this.CameraDevice.forEach((item, index) => {
            if (index == e.currentIndex) {
              this.url = item.hdAddress;
            }
          });
          this.initPlayer();
        }
      }
    },

    timeToTimestamp(date) {
      // let timestamp = Date.parse(new Date(time).toString());
      // //timestamp = timestamp / 1000; //时间戳为13位需除1000，时间戳为13位的话不需除1000
      // console.log(time + "的时间戳为：" + timestamp);

      var y = date.getFullYear();
      var m = date.getMonth() + 1; //注意这个“+1”
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;

      return y + "" + m + "" + d + "" + h + "" + minute + "" + second;
    },
    //获取监控
    CameraDeviceReq() {
      CameraDevice(this.storeId).then((res) => {
        if (res.code == "0") {
          this.accessToken = res.data.accessToken;

          this.CameraDevice = res.data.cameraDevices;
          this.$forceUpdate();
          res.data.cameraDevices.forEach((item, index) => {
            // let name = (index + 1) + "号摄像头"
            // const inputString = "河南样板店2号摄像头";
            const regex = /\d.*/; // 正则表达式：\d 匹配数字，.* 匹配任意字符（除了换行符）直到字符串末尾
            const result = item.deviceName.match(regex);
            if (result) {
              const extractedString = result[0];
              this.items.push(extractedString);
            } else {
              this.items.push("未命名摄像头");
              // console.log("未找到数字开始的子字符串");
            }

            setTimeout(() => {
              this.initPlayer(item);
            }, 1000);
          });
          // this.url = this.CameraDevice[0].hdAddress
        } else {
        }
      });
    },

    getCameraUserDevice(id) {
      CameraUserDevice(id).then((res) => {
        if (res.code == "0") {
          this.JinMneList = res.data;
          if (this.JinMneList[0].phone) {
            this.userPhone = this.JinMneList[0].phone;
          } else {
            this.userPhone = "";
            this.userId = this.JinMneList[0].wxUserId;
          }
        } else {
        }
      });
    },

    queryorderById(id) {
      orderById(id).then((res) => {
        if (res.code == "0") {
          this.OrderDesc = res.data;
          this.OrderDesc.OrderColor = this.ColorStatus.get(
            res.data.orderStatus.toString()
          );
          this.OrderDesc.orderStatus = this.orderStatus.get(
            res.data.orderStatus.toString()
          );
        } else {
        }
      });
    },

    initPlayer(data) {
      let width = window.screen.width;
      let height = window.screen.height * 2 - window.screen.availHeight;
      console.log(data);
      let nowplay = new EZUIKit.EZUIKitPlayer({
        // id: 'video-container' + this.cameras[i-1].id, // 视频容器ID
        id: "video-container" + data.id, // 视频容器ID

        accessToken: this.accessToken,

        // accessToken: this.accessToken,
        // accessToken: 'at.228no5gc4pnrqo4u4oqu6qoz50bujs4e-73tal3pjem-18q833x-jk0khqp66',

        // url: data[i - 1].processAddress,
        url: data.url ? data.url : data.hdAddress,

        // url: 'ezopen://open.ys7.com/L05927015/1.live',
        // url: 'ezopen://open.ys7.com/L05927015/1.live',
        // url:this.cameras[i].processAddress,
        // url: this.videos[i], // 视频地址

        // simple - 极简版; pcLive-pc直播；pcRec-pc回放；mobileLive-移动端直播；mobileRec-移动端回放;security - 安防版;voice-语音版;

        // template: template,
        template: "security",
        // template: '1836b580bb634553bfdb7fb1db9a249e',

        plugin: ["talk"], // 加载插件，talk-对讲
        width: width,
        height: height,
        // useHardDev: true //开启高性能模式
      });
      nowplay.storeId = data.storeId;

      nowplay.deviceName = data.deviceName;
      // nowplay.on('error', this.EZUIKitError(data.id));

      this.player.push(nowplay);
    },
    CameraDeviceList() {
      console.log("typeofSingle", typeof this.single);
      let a = {
        storeId: this.storeId,
        time: this.single,
      };
      CameraDeviceListreq(a).then((res) => {
        if (res.code == "0") {
          // this.CameraDeviceLogList = res.data
          this.CameraDeviceLogList = [];
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];

            // res.data.forEach(item => {
            let camerlog = "";
            if (item.phone != null && item.operate == 0) {
              camerlog =
                "尾号[" + item.phone.slice(-4) + "]的[" + item.desctions + "]";
            }
            if (item.phone == null && item.operate == 0) {
              camerlog =
                "客户id[" + item.wxUserId + "]的[" + item.desctions + "]";
            }
            if (item.adminId != null && item.operate == 0) {
              camerlog = "客服[" + item.adminId + "]远程开门";
            }
            if (item.businessId != null && item.operate == 0) {
              camerlog = "商户[" + item.businessId + "]远程开门";
            }
            if (item.operate == 1 && item.adminId != null) {
              camerlog = "客服【" + item.adminId + "】解锁门店";
            }
            if (item.operate == 1 && item.businessId != null) {
              camerlog = "商户【" + item.businessId + "】解锁门店";
            }
            if (item.operate == 2 && item.adminId != null) {
              camerlog = "客服【" + item.adminId + "】常闭门店";
            }
            if (item.operate == 2 && item.businessId != null) {
              camerlog = "商户【" + item.businessId + "】常闭门店";
            }
            if (item.operate == 3) {
              camerlog =
                "用户【" + item.businessId + item.adminId + "】上线云值守";
            }
            if (item.operate == 4) {
              camerlog =
                "用户【" + item.businessId + item.adminId + "】下线云值守";
            }
            if (item.operate == 5) {
              camerlog = "客服打开对讲[" + item.desctions + "]";
            }
            if (item.operate == 6) {
              camerlog = "客服结束对讲[" + item.desctions + "]";
            }
            if (item.operate == 7) {
              camerlog = item.desctions;
            }
            if (item.operate == 8) {
              camerlog = "客户买单[" + item.desctions + "]";
            }
            if (item.operate == 9) {
              // 联系客服
              // camerlog = item.desctions
              continue;
            }

            item.camerlog = camerlog;
            this.CameraDeviceLogList.push(item);
            // })
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.bigBox {
  display: flex;
  width: 80vw;
  flex-wrap: wrap;
  align-content: space-between;
  justify-content: space-between;
}
.bigBox > div {
  flex-basis: 20%;
}
@import url(./Dashboard.css);

@media screen and (max-width: 749px) {
  /deep/ .el-col {
    gap: 50px;
  }

  .handle-box {
    flex-wrap: wrap;
  }

  /deep/ .BigClass1 {
    width: 100vw !important;
  }

  /deep/ .ChuanKou {
    width: 100vw !important;
    height: 60vh;
    /*height: calc((100vh - 94px)/4) !important;*/
  }

  /deep/ div[class$="parent-wnd"] {
    width: 100vw !important;
    height: 60vh !important;
  }

  /deep/ .BigClass {
    width: 100vw !important;
    height: 60vh !important;
  }

  /deep/ .BianDa {
    width: 100vw !important;
    height: 60vh !important;
  }

  /deep/ .VideoIndex {
    gap: 50px;
  }
}

@media screen and (min-width: 749px) {
  /deep/ .el-select .el-input__inner {
    width: 7vw !important;
  }

  /deep/ .el-button--small {
    padding: 9px 1vw;
  }

  /deep/ .el-select .el-input {
    width: 7vw !important;
  }

  /deep/ .el-input__inner {
    width: 10vw;
  }

  /deep/ .el-input {
    width: 10vw;
  }

  /deep/ .BigClass1 {
    width: 40vw !important;
    height: calc(83vh + 32px) !important;
  }

  /deep/ .ChuanKou {
    width: calc((100vw - 20px) / 4) !important;

    /*height: calc((100vh - 94px)/4) !important;*/
  }

  /deep/ div[class$="parent-wnd"] {
    width: calc((100vw - 20px) / 4) !important;

    height: calc((100vh - 94px) / 4) !important;
  }

  /deep/ .BigClass2 {
    width: 40vw !important;
    height: 83vh !important;
  }

  /deep/ .BigClass {
    width: 40vw !important;
    height: 83vh !important;
  }

  /deep/ .BigClass div:first-child {
    width: 40vw !important;
    height: 83vh !important;
  }

  /deep/ .BianDa {
    width: 40vw !important;
    height: 83vh !important;
  }

  /deep/ canvas[class$="play-window"] {
    width: calc((100vw - 20px) / 4) !important;

    height: calc((100vh - 94px) / 4) !important;
  }

  .VideoIndex {
    display: revert !important;
  }
}

.HenFu {
  margin: -10px 0px 5px -10px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 14px;
  padding: 3px;
  display: flex;
  justify-content: center;
}

.HenFu1 {
  margin: -10px 0px 5px -10px;
  background-color: #fa9403;
  color: #fff;
  font-size: 14px;
  padding: 3px;
  display: flex;
  justify-content: center;
}

/deep/ .el-tag--light {
  padding: 9px 15px !important;
  height: auto !important;
  line-height: normal !important;
}

/deep/ .QuanPing2 {
  width: 100vw !important;
  height: 100vh !important;
}

/deep/ .QuanPing {
  width: 100vw !important;
  height: 100vh !important;
}

/deep/ .BianXiao {
  width: auto !important;
  height: auto !important;
}

.handle-box {
  display: flex;
  /*width: 40vw;*/
  /*margin: 1vh 0 2vh 0;*/
  gap: 2vw;
}

/deep/ .el-col-Div {
  margin: 1vh 0.5vw;
  height: auto !important;
  /* background-color: #f56c6c !important; */
}
.el-col-Div {
  width: calc((100vw - 20px) / 4);
}
.header-controls-left {
  width: 100%;
}
.el-col-Div > :first-child > :nth-child(2) {
  /* 修改样式 */
  width: calc((100vw - 20px) / 4) !important;
  line-height: calc((100vh - 94px) / 4) !important;
}
.el-col-Div > :first-child {
  /* 修改样式 */
  width: calc((100vw - 20px) / 4) !important;
  /* height: calc((100vh - 94px) / 4) !important; */
}
/deep/ div[class$="el-col-Div"] div:nth-child(2) {
  /* width: calc((100vw  - 20px) / 4) !important; */
  height: auto !important;
  /* line-height: calc((100vh - 94px) / 4) !important; */
}

/deep/ .el-col {
  /*display: revert !important;*/
}

/deep/ .loading-item {
  width: auto !important;
  height: auto !important;
  position: revert !important;
}

/deep/ div[id$="audioControls"] {
  /*pointer-events: none !important;*/
}

/deep/ div[class$="parent-wnd"] div:first-child {
  width: auto !important;
  height: auto !important;
}

/deep/ canvas[id$="canvas_draw0"] {
  width: 100vw;
  height: 100vh;
}

/deep/ div[id$="loading-id-0"] {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100% !important;
}

/*/deep/ div[id="video-container"]{*/
/*    display: flex;*/
/*    align-items: center;*/
/*    justify-content: center;*/
/*}*/

/deep/ .header-controls {
  height: 32px !important;
  line-height: 32px !important;
  width: calc((100vw - 20px) / 4) !important;
}

/deep/ .footer-controls {
  display: flex !important;
  /* width: calc((100vw  - 20px) / 12) !important; */
}

/*/deep/ div[id$="wrap"] div:nth-child(1){*/
/*    width: calc((100vh - 94px)/4) !important;*/
/*    height: calc((100vh - 94px)/4) !important;*/
/*}*/
/*/deep/ div[id^="video-container"]{*/
/*    width: calc((100vh - 94px)/4) !important;*/
/*    height: calc((100vh - 94px)/4) !important;*/
/*}*/

/deep/ .ez-iframe-footer-container {
  display: none;
  width: calc((100vw - 20px) / 4) !important;
}
/deep/ .header-controls-left {
  width: 100% !important;
}

.el-dialog__body > div {
  overflow-y: scroll;
}
/deep/ .el-dialog__body .el-input__inner {
  width: 100% !important;
}

/* 进门记录弹窗 */
.PopTitle {
  display: flex;
  justify-content: space-between;
  margin: 10px;
}
.PopTitleText {
  font-size: 20px;
}
.PopDel {
}
.PopDelImg {
  width: 20px;
  height: 20px;
}

/*/deep/ .VideoDiv div:nth-child(2){*/
/*    width: 100% !important;*/
/*    !*height: calc(20.5vh) !important;*!*/
/*    height: calc((100vh - 94px)/4) !important;*/
/*}*/
/*/deep/ .VideoDiv div:nth-child(2) div{*/
/*    width: 100% !important;*/
/*    !*height: calc(20.5vh) !important;*!*/
/*    height: calc((100vh - 13.45vh - 20px)/4) !important;*/
/*}*/
/*/deep/ .VideoDiv div:nth-child(2) div canvas:first-child{*/
/*    width: 100% !important;*/
/*    !*height: calc(20.5vh) !important;*!*/
/*    height: calc((100vh - 13.45vh - 20px)/4) !important;*/
/*}*/
/*/deep/ .el-col-6 div:first-child{*/
/*    width: 100% !important;*/

/*}*/

/*/deep/ .video-container3parent-wnd div{*/

/*    width: 100% !important;*/
/*    !*height: calc(20.5vh) !important;*!*/
/*    height: calc((100vh - 13.45vh - 20px)/4) !important;*/

/*}*/
/*/deep/ .el-col-6 div canvas{*/

/*    width: 100% !important;*/
/*    !*height: calc(20.5vh)  !important;*!*/
/*    height: calc((100vh - 13.45vh - 20px)/4) !important;*/

/*}*/
</style>







// WEBPACK FOOTER //
// src/views/charts/jiankong.vue